import { useEffect } from "react";

const BASE_TITLE = "The People Collective | HR Consultancy in Ontario";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export function useSeo({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | The People Collective` : BASE_TITLE;
    document.title = fullTitle;

    setMeta("description", description);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description);

    const origin =
      typeof window !== "undefined" ? window.location.origin : "";
    setCanonical(`${origin}${path}`);
  }, [title, description, path]);
}
